import script from "./addStorePage.vue?vue&type=script&setup=true&lang=js"
export * from "./addStorePage.vue?vue&type=script&setup=true&lang=js"

import "./addStorePage.vue?vue&type=style&index=0&id=0d895be4&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d895be4"]])

export default __exports__